











import { Component, Vue, Prop } from 'vue-property-decorator'
import JsonCSV from 'vue-json-csv'
Vue.component('downloadCsv', JsonCSV)

@Component({ components: { 'downloadCsv':  JsonCSV } })
export default class Downloader extends Vue {
   @Prop() data
   @Prop() name
}

